ALLOWED_CONTROLLER = 'ui_nodes'
ALLOWED_ACTIONS = ['edit', 'update']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  $('*[data-selector="calendar"]').datepicker();

$(document).ready(ready)
$(document).on('turbo:load', ready)



